<template>
    <v-list nav dense shaped>
        <context-tree-view-group  
            v-for="(context, idx) in dataSource"              
            :key="context.Id || 'r' + idx"
            :item="context"
            :initially-open="false"
            :itemClick="itemClick"
        />
    </v-list>
  </template>
  
  <script>
  import ContextTreeViewGroup from './ContextTreeViewGroup.vue';
  
  export default {
    components: {
        ContextTreeViewGroup
    },
    props: {
        dataSource: {
            type: Array,
            default: () => []
        },
        itemClick: {
            type: Function,
            default: null
        }
    },
    data() {
      return {
      };
    },
    methods: {
    }
  }
  </script>